
let injected = false;
export default {

  toHtml(json) {
    this.injectJsonStyle();
    if (typeof json != 'string') {
      json = JSON.stringify(json, undefined, 2);
    }
    json = json.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/\n/g, '<br/>').replace(/\s/g, '&nbsp;');
    return json.replace(/("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g, function (match) {
      var cls = 'number';
      if (/^"/.test(match)) {
        if (/:$/.test(match)) {
          cls = 'j-html-key';
        } else {
          cls = 'j-html-string';
        }
      } else if (/true|false/.test(match)) {
        cls = 'j-html-boolean';
      } else if (/null/.test(match)) {
        cls = 'j-html-null';
      }
      return '<span class="' + cls + '">' + match + '</span>';
    });
  },

  injectJsonStyle() {
    // only inject once
    if (injected) return;
    let css = document.createElement('style');
    // css.type = 'text/css';
    css.appendChild(document.createTextNode('pre{outline:1px solid #ccc;padding:5px;margin:5px}.j-html-string{color:green}.number{color:#ff8c00}.j-html-boolean{color:#00f}.j-html-null{color:#ff00ff}.j-html-key{color:red}')); // Support for the rest
    document.getElementsByTagName("head")[0].appendChild(css);
    injected = true;
  }
}
